// Function to get CSS variable value
function getCSSVariable(variableName) {
  if (typeof window !== "undefined" && window.getComputedStyle) {
    return getComputedStyle(document.documentElement)
      .getPropertyValue(variableName)
      .trim();
  }
  // Fallback values if DOM is not available
  return "#29bdf0"; // Original blue color as fallback
}

// Get the app primary color from CSS variable
const appPrimaryBase = getCSSVariable("--app-primary-base") || "#29bdf0";

export default {
  options: {
    customProperties: true,
  },
  light: true,
  themes: {
    light: {
      primary: {
        base: "#32383d",
        darken1: "#1e2329",
        lighten1: "#2c3e50",
      },
      secondary: {
        base: "#dcdcdd",
        darken1: "#515358",
        lighten1: "#f8f8f8",
      },

      accent: { base: appPrimaryBase },
      success: "#417505",
      warning: "#F5A623",
      error: "#930012",
      danger: "#ed4337",
    },
  },
};



// WEBPACK FOOTER //
// ./src/theme.js